import { useContext, useEffect, useRef, useState } from 'react';
import css from './GTCategories.module.scss';
import { StoreContext } from '../../../../../../common/utils/getContext';
import { Img, svgSprite } from '../../../../../../hybrid/wrappers';
import classNames from 'classnames';
import T from '../../../../../../common/components/T';
import { navigateV2 } from '../../../../../../common/utils/router';
import SingleButton from '../../../../../../widgets/form/form-control-buttons/SingleButton/SingleButton';
import { checkBrowser } from '../../../../../../common/utils/utils';

const CategoryComponent = ({ category, key, closeHandler }) => {
    return (
        <div
            onClick={() => {
                navigateV2(`/store/category/${category.url}`);
                closeHandler();
            }}
            key={key}
            className={css.category}
        >
            <div className={css.categoryLeft}>
                <div className={classNames(css.categoryImg, { [css.categoryImgNo]: !category?.image?.links?.preview })}>
                    {category?.image?.links?.preview ? (
                        <Img src={category?.image?.links?.preview} alt={category?.name} />
                    ) : (
                        svgSprite('product-no-image')
                    )}
                </div>
                <div className={css.categoryInfo}>
                    <p className={css.categoryLabel}>
                        <T textName='category' defaultStr='Категория' page='/store' />
                    </p>
                    <p className={css.categoryName}>{category?.name}</p>
                </div>
            </div>
            <div className={classNames('circleButton', css.categoryButton)}>{svgSprite('arrow-right-gt-store')}</div>
        </div>
    );
};

export default function GTCategories({ closeHandler }) {
    const { categories } = useContext(StoreContext);
    const modalRef = useRef();

    // сетер для timestamp щоб змінювати позицію вікна при скролі
    const [eventTimestamp, setEventTimestamp] = useState(0);

    useEffect(() => {
        const header = document.querySelector('header');
        if (header && modalRef?.current && categories && categories?.length > 0) {
            const headerCoords = header.getBoundingClientRect();
            const modalTopCoords = headerCoords.bottom;
            modalRef.current.style.top = `${checkBrowser(modalTopCoords)}px`;
        }
    }, [eventTimestamp, categories]);

    // функція щоб змінювати позицію вікна при скролі
    useEffect(() => {
        const listener = (e) => {
            setEventTimestamp(e.timeStamp);
        };
        document.addEventListener('scroll', listener);
        return () => {
            document.removeEventListener('scroll', listener);
        };
    }, []);

    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, []);

    useEffect(() => {
        if (modalRef.current) {
            let startX, startY, endX, endY;

            const handleTouchStart = (event) => {
                startX = event.touches ? event.touches[0].clientX : event.clientX;
                startY = event.touches ? event.touches[0].clientY : event.clientY;
            };

            const handleTouchMove = (event) => {
                endX = event.touches ? event.touches[0].clientX : event.clientX;
                endY = event.touches ? event.touches[0].clientY : event.clientY;
            };

            const handleTouchEnd = () => {
                const deltaX = endX - startX;
                const deltaY = endY - startY;

                if (Math.abs(deltaX) > Math.abs(deltaY)) {
                    // Горизонтальний свайп
                    if (deltaX > 0) {
                    } else {
                    }
                } else {
                    // Вертикальний свайп
                    if (deltaY < 0) {
                        closeHandler();
                    } else {
                    }
                }
            };

            // Додаємо обробники для сенсорних подій
            modalRef.current.addEventListener('touchstart', handleTouchStart);
            modalRef.current.addEventListener('touchmove', handleTouchMove);
            modalRef.current.addEventListener('touchend', handleTouchEnd);

            // Додаємо обробники для миші
            modalRef.current.addEventListener('mousedown', handleTouchStart);
            modalRef.current.addEventListener('mousemove', handleTouchMove);
            modalRef.current.addEventListener('mouseup', handleTouchEnd);

            return () => {
                if (modalRef.current) {
                    // Додаємо обробники для сенсорних подій
                    modalRef.current.removeEventListener('touchstart', handleTouchStart);
                    modalRef.current.removeEventListener('touchmove', handleTouchMove);
                    modalRef.current.removeEventListener('touchend', handleTouchEnd);

                    // Додаємо обробники для миші
                    modalRef.current.removeEventListener('mousedown', handleTouchStart);
                    modalRef.current.removeEventListener('mousemove', handleTouchMove);
                    modalRef.current.removeEventListener('mouseup', handleTouchEnd);
                }
            };
        }
    }, [modalRef.current, closeHandler]);

    if (!categories || categories.length === 0) return null;
    return (
        <div onMouseOver={closeHandler} className={css.bg} ref={modalRef}>
            <div
                onMouseOver={(e) => {
                    e.stopPropagation();
                }}
                className={css.whiteBg}
            >
                <div className={css.whiteBGImage}>
                    <SingleButton
                        customButton={{ singleButton: css.collapseBtn }}
                        type={'cancel'}
                        buttonText={<T textName='collapse' defaultStr='Свернуть' />}
                        clickFunc={closeHandler}
                    />
                    <div className={css.content}>
                        {categories?.map((category) => (
                            <CategoryComponent closeHandler={closeHandler} category={category} key={category.id} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
